import styled from 'styled-components';
import SvgInfo from '../../../others/svg_dist/Info';

export const Wrapper = styled.div`
	background-color: #f5f5f5;
	padding: 30px 0;
	scroll-margin-top: 200px;
`;

export const Background = styled.div`
	width: 96%;
	margin: 0 auto;
	background: linear-gradient(135deg, #e5e5e5 25%, transparent 25%),
		linear-gradient(225deg, #e5e5e5 25%, transparent 25%),
		linear-gradient(315deg, #e5e5e5 25%, transparent 25%),
		linear-gradient(45deg, #e5e5e5 25%, transparent 25%);
	background-size: 8px 8px;
	padding-bottom: 40px;
	@media screen and (max-width: 1000px) {
		width: 100%;
	}
`;

export const TopHeadingFont = styled.p`
	font-size: 26px;
	font-weight: 600;
	text-align: center;
	margin: 0px;
	margin-left: 10px;
	line-height: 1.3;
`;

export const BottomHeadingFont = styled.p`
	text-align: center;
	margin: 0px;
	font-size: 12px;
	span {
		color: #ffb222;
	}
`;

export const ConsentsContainer = styled.div`
	width: 60%;
	margin: 20px auto;
	background-color: #fff;
	border-radius: 10px;
	padding-bottom: 10px;
	@media screen and (max-width: 1000px) {
		width: 98%;
	}
`;

export const ConsentsHeadingContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	padding: 10px 20px;
`;

export const ConsentsContentContainer = styled.div`
	width: 98%;
	margin: 0 auto;
	display: flex;
	flex-flow: column nowrap;
	overflow-y: auto;
	max-height: 400px;
	padding: 10px;
	border-radius: 10px;
	position: relative;
	scrollbar-width: thin;
	background-color: #fafafa;
`;

export const ItemContainer = styled.div`
	width: 100%;
	padding: 10px;
	transition: background-color 75ms linear;
	&:hover {
		background-color: #fff;
	}
	&:not(:last-child) {
		border-bottom: 1px solid #eeeeee;
	}
	& label:first-child {
		min-width: 16px;
		align-self: flex-start;
	}
	& label {
		text-transform: unset;
		font-size: 14px;
		text-align: justify;
	}
`;

export const Reqstart = styled.span`
	font-size: 14px;
	color: #ffb222;
`;

export const StyledSvgInfo = styled(SvgInfo)`
	width: 35px;
	height: 35px;
	fill: #d66464;
`;

export const HeadingTopFontContainer = styled.div`
	display: flex;
	align-items: center;
	padding-top: 35px;
	justify-content: center;
`;
